import { PendingMessage } from './types'
import { pendingMessagesStorage } from './storage'

export async function deletePendingMessages(ids: string[]) {
  pendingMessagesStorage.deleteMany(ids)
}

export async function createPendingMessages(messages: PendingMessage[]) {
  await pendingMessagesStorage.insert(messages)
}

export function getAllPendingMessages() {
  return pendingMessagesStorage.getAll()
}
